(() => {
  'use strict';

  if (window.__IBLocalizationSubmitV3) return;
  window.__IBLocalizationSubmitV3 = true;
  window.__IBLocalizationCountryLanguage = true;

  // Default locales verified against the 65 active Shopify Markets on 2026-10-21.
  const preferredLocaleByCountry = {
    "AL": "en",
    "DE": "de",
    "AD": "ca",
    "AR": "es",
    "AU": "en",
    "AT": "de",
    "BE": "fr",
    "BO": "es",
    "BA": "en",
    "BR": "pt-BR",
    "BG": "en",
    "CA": "en",
    "CZ": "en",
    "CL": "es",
    "CY": "en",
    "VA": "it",
    "CO": "es",
    "CR": "es",
    "HR": "en",
    "DK": "en",
    "EC": "es",
    "SK": "en",
    "SI": "en",
    "ES": "es",
    "US": "en",
    "EE": "en",
    "FI": "en",
    "FR": "fr",
    "GR": "en",
    "GT": "es",
    "HN": "es",
    "HU": "en",
    "IN": "en",
    "IE": "en",
    "IS": "en",
    "IT": "it",
    "JP": "en",
    "XK": "en",
    "LV": "en",
    "LI": "de",
    "LT": "en",
    "LU": "fr",
    "MK": "en",
    "MT": "en",
    "MX": "es",
    "MD": "en",
    "MC": "fr",
    "ME": "en",
    "NI": "es",
    "NO": "en",
    "NL": "nl",
    "PA": "es",
    "PY": "es",
    "PE": "es",
    "PL": "en",
    "PT": "pt-PT",
    "GB": "en",
    "DO": "es",
    "RO": "en",
    "SM": "it",
    "RS": "en",
    "SE": "en",
    "CH": "de",
    "TR": "en",
    "UY": "es"
  };
  const countrySelector = '.localization-form__list-item[data-value]';
  const pendingForms = new Map();

  const contextFor = (element) => {
    const component = element.closest('localization-form-component');
    const form = component?.querySelector('form.localization-form');
    if (!(form instanceof HTMLFormElement) || !form.contains(element)) return null;
    try {
      const action = new URL(form.getAttribute('action') || '', location.href);
      if (!/^https?:$/.test(action.protocol) || !/\/localization\/?$/.test(action.pathname)) return null;
    } catch (_) { return null; }
    return { component, form };
  };

  const chooseCountryLanguage = (form, country) => {
    const input = form.querySelector('select[name="language_code"]');
    const preferred = preferredLocaleByCountry[country];
    if (!(input instanceof HTMLSelectElement) || !preferred) return;

    // The destination locale may be absent from the origin market's options.
    // Submit its exact locale; a base-language fallback would confuse pt-BR and pt-PT.
    let option = Array.from(input.options).find(
      (candidate) => candidate.value.toLowerCase() === preferred.toLowerCase()
    );
    if (!option) {
      option = document.createElement('option');
      option.value = preferred;
      option.textContent = preferred;
      option.dataset.ibCountryLocale = 'true';
      input.add(option);
    }
    option.disabled = false;
    input.value = option.value;
  };

  const prepareReturnTo = (form) => {
    let field = form.querySelector('input[name="return_to"]');
    const current = new URL(location.href);
    let target;
    try {
      target = new URL(field?.value || `${current.pathname}${current.search}${current.hash}`, current);
      if (target.origin !== current.origin) return;
    } catch (_) { return; }
    if (target.pathname === current.pathname) {
      current.searchParams.forEach((value, key) => {
        if (!target.searchParams.has(key)) target.searchParams.set(key, value);
      });
      if (!target.hash) target.hash = current.hash;
    }
    ['preview_theme_id', 'preview_token'].forEach((key) => {
      if (current.searchParams.has(key)) target.searchParams.set(key, current.searchParams.get(key));
    });
    ['country', 'country_code', 'language', 'language_code', 'locale'].forEach((key) =>
      target.searchParams.delete(key)
    );
    if (!(field instanceof HTMLInputElement)) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = 'return_to';
      form.appendChild(field);
    }
    field.value = `${target.pathname}${target.search}${target.hash}`;
  };

  const unlock = (form) => {
    window.clearTimeout(pendingForms.get(form));
    pendingForms.delete(form);
    form.removeAttribute('aria-busy');
  };

  const submit = (form, event) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (pendingForms.has(form)) return;
    prepareReturnTo(form);
    form.setAttribute('aria-busy', 'true');
    pendingForms.set(form, window.setTimeout(() => unlock(form), 2500));
    try {
      HTMLFormElement.prototype.submit.call(form);
    } catch (error) {
      unlock(form);
      console.error('[Install Beer] Localization form could not be submitted.', error);
    }
  };

  const selectCountry = (item, event) => {
    if (item.closest('[hidden], [inert]') || item.getAttribute('aria-disabled') === 'true') return;
    const context = contextFor(item);
    const country = String(item.dataset.value || '').toUpperCase();
    if (!context || !/^[A-Z]{2}$/.test(country)) return;
    const input = context.form.querySelector('input[name="country_code"]');
    if (!(input instanceof HTMLInputElement)) return;
    if (!pendingForms.has(context.form)) {
      input.value = country;
      chooseCountryLanguage(context.form, country);
    }
    submit(context.form, event);
  };

  window.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const item = event.target.closest(countrySelector);
    if (item) selectCountry(item, event);
  }, true);

  window.addEventListener('keydown', (event) => {
    if (event.isComposing || event.repeat || !['Enter', ' '].includes(event.key)) return;
    if (!(event.target instanceof Element)) return;
    const item = event.target.closest(countrySelector);
    if (item) selectCountry(item, event);
  }, true);

  window.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLSelectElement) || input.name !== 'language_code' || input.disabled) return;
    const context = contextFor(input);
    if (!context || !input.value || input.selectedOptions[0]?.disabled) return;
    submit(context.form, event);
  }, true);

  window.addEventListener('pageshow', () => {
    Array.from(pendingForms.keys()).forEach(unlock);
  });
})();